export default class GetCoveragesCompleteRequest {
  businessLine: string | undefined
  insuranceType: string | undefined
  clientCode: string | undefined
  productCode: string | undefined

  constructor(data: Partial<GetCoveragesCompleteRequest>) {
    const humanizedProcess = !data.clientCode && !data.productCode

    if (humanizedProcess) {
      if (!data.businessLine) throw new Error('"businessLine" is required')
      if (!data.insuranceType) throw new Error('"insuranceType" is required')

      this.clientCode = undefined
      this.productCode = undefined
      this.businessLine = data.businessLine
      this.insuranceType = data.insuranceType
    } else {
      if (!data.clientCode) throw new Error('"clientCode" is required')
      if (!data.productCode) throw new Error('"productCode" is required')

      this.clientCode = data.clientCode
      this.productCode = data.productCode
      this.businessLine = undefined
      this.insuranceType = undefined
    }
  }
}
